// import { config } from "./config.service";
import * as rawConfig from "../siteConfig.json";

import axios from 'axios';

import config_general from './../config_general.json'


export class BackendService {
   
    private baseURL;
    constructor(baseURL: string) {
        if (baseURL.startsWith("/")) {
            this.baseURL =
                window.location.protocol + "//" + window.location.host + baseURL;
        } else {
            this.baseURL = baseURL;
        }
    }
    private makeRequest(url: string, params: any) {
        const fullParams = { ...params };
        if ([null, undefined].includes(fullParams["headers"])) {
            fullParams["headers"] = {
                "content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
            };
        } else {
            fullParams["headers"]["content-type"] = "application/json";
            fullParams["headers"]["Access-Control-Allow-Origin"] = "*";
        }
        return fetch(url, fullParams)
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }

    // get names
    getFires() {
        const url = new URL(this.baseURL + "firms/geojson");
        return this.makeRequest(url.toString(), {});
    }

    getLatestDate() {
        const url = new URL(this.baseURL + "firms/latest_date");
        return this.makeRequest(url.toString(), {});
    }
}

export const backendService = new BackendService(config_general.general.backendUrl);
